import UserCenter from "@/views/personalCenter/index.vue";

export const personalRoutes = [
  // 个人中心
  {
    path: "/controlCenter",
    component: UserCenter,
    redirect: "/controlCenter/personal-setting",
    meta: {
      title: "personalCenter",
    },
    children: [
      {
        path: "/controlCenter/personal-setting",
        name: "personal-setting",
        component: () =>
          import(
            "@/views/personalCenter/personal-setting/personal-setting.vue"
          ),
        meta: {
          title: "个人设置",
        },
      },
      {
        path: "/controlCenter/account-authentication",
        name: "account-authentication",
        meta: {
          title: "账号认证",
        },
        component: () =>
          import("@/views/personalCenter/account-authentication/index.vue"),
      },
      {
        path: "/controlCenter/my-feedback",
        name: "/my-feedback",
        meta: {
          title: "我的反馈",
        },
        component: () => import("@/views/personalCenter/my-feedback/index.vue"),
      },
      {
        path: "/controlCenter/my-order",
        name: "my-order",
        component: () => import("@/views/personalCenter/my-order/index.vue"),
        meta: {
          title: "我的订单",
        },
      },
      {
        path: "/controlCenter/renewal-management",
        name: "renewal-management",
        component: () =>
          import("@/views/personalCenter/renewed-management/index.vue"),
        meta: {
          title: "续订管理",
        },
      },
      {
        path: "/controlCenter/postpaid-list",
        name: "postpaid-list",
        component: () =>
          import("@/views/personalCenter/postpaid-list/index.vue"),
        meta: {
          title: "流量费",
        },
      },
      {
        path: "/controlCenter/postpaid-pay/:id",
        name: "postpaid-pay",
        component: () =>
          import("@/views/personalCenter/components/postpaid-pay.vue"),
        meta: {
          title: "后付费支付",
        },
      },
      {
        path: "/controlCenter/bill-management",
        name: "bill-management",
        component: () =>
          import("@/views/personalCenter/bill-management/index.vue"),
        meta: {
          title: "账单管理",
        },
      },
      {
        path: "/controlCenter/coupon-management",
        name: "coupon-management",
        component: () =>
          import("@/views/personalCenter/coupon-management/index.vue"),
        meta: {
          title: "优惠券管理",
        },
      },
      {
        path: "/controlCenter/recharge",
        name: "recharge",
        component: () =>
          import("@/views/personalCenter/recharge-record/recharge.vue"),
        meta: {
          title: "充值",
        },
      },
      {
        path: "/controlCenter/recharge-history",
        name: "recharge-history",
        component: () =>
          import("@/views/personalCenter/recharge-record/recharge-history.vue"),
        meta: {
          title: "充值记录",
        },
      },
      {
        path: "/controlCenter/running-tab",
        name: "running-tab",
        component: () =>
          import("@/views/personalCenter/recharge-record/running-tab.vue"),
        meta: {
          title: "交易流水",
        },
      },
      {
        path: "/controlCenter/shopping-cart",
        name: "shopping-cart",
        component: () =>
          import("@/views/personalCenter/shopping-cart/shopping-cart.vue"),
        meta: {
          title: "购物车",
        },
      },
      {
        path: "/controlCenter/unfreeze-astrict",
        name: "unfreeze-astrict",
        component: () =>
          import(
            "@/views/personalCenter/unfreeze-astrict/unfreeze-astrict.vue"
          ),
        meta: {
          title: "解除限制",
        },
      },
    ],
  },
];
